import { lazy } from 'react';
// it is vital that the constants are declared outside of the export object.
// you must declare the accompanying post in globals.js, and the key value in the articles object must be the same as the date in globals.js
const ARTICLE_2025_04_12 = lazy(() => import('./components/articles/2025-04-12'));
const ARTICLE_2025_03_18 = lazy(() => import('./components/articles/2025-03-18'));
const ARTICLE_2025_02_27 = lazy(() => import('./components/articles/2025-02-27'));
const ARTICLE_2025_04_21 = lazy(() => import('./components/articles/2025-04-21'));
const ARTICLE_2025_04_07 = lazy(() => import('./components/articles/2025-04-07'));
const ARTICLE_2025_05_02 = lazy(() => import('./components/articles/2025-05-02'));
const ARTICLE_2025_06_02 = lazy(() => import('./components/articles/2025-06-02'));
const ARTICLE_2025_06_15 = lazy(() => import('./components/articles/2025-06-15'));

export const articles ={
    '2025-04-12': ARTICLE_2025_04_12,
    '2025-03-18': ARTICLE_2025_03_18,
    '2025-02-27': ARTICLE_2025_02_27,
    '2025-04-21': ARTICLE_2025_04_21,
    '2025-04-07': ARTICLE_2025_04_07,
    '2025-05-02': ARTICLE_2025_05_02,
    '2025-06-02': ARTICLE_2025_06_02,
    '2025-06-15': ARTICLE_2025_06_15,
};


